import { render, staticRenderFns } from "./OurPracticeBackground.vue?vue&type=template&id=c8ade51c&scoped=true&"
import script from "./OurPracticeBackground.vue?vue&type=script&lang=js&"
export * from "./OurPracticeBackground.vue?vue&type=script&lang=js&"
import style0 from "./OurPracticeBackground.vue?vue&type=style&index=0&id=c8ade51c&scoped=true&lang=css&"
import style1 from "./OurPracticeBackground.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ade51c",
  null
  
)

export default component.exports